// Access requests (the admin's queue) and Request access (the public form) — the screens' strings in the portal's
// four languages (2026-10-21). What applicants typed (names, companies, reasons) is data and is not in here.
const en = {
  col: {
    asked: 'Asked',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    contact: 'Helinox contact',
    reason: 'What for',
    status: 'Outcome',
    decidedBy: 'By',
    decidedAt: 'When',
    note: 'Note',
    username: 'Username',
    action: 'Action',
  },
  status: {
    approved: 'Approved',
    rejected: 'Rejected',
    pending: 'Pending',
  },
  loadFailed: 'Could not read the requests.',
  failed: 'That did not go through.',
  rejectedMsg: 'Rejected. The applicant has been emailed your reason.',
  recorded: 'Recorded.',
  filterBit: '{{col}}: {{values}}',
  sortedBy: 'sorted by {{col}}',
  showing: 'Showing {{shown}} of {{total}} — {{bits}}',
  clear: 'Clear',
  title: 'Access requests',
  refresh: 'Refresh',
  users: 'Users',
  note: 'People outside Helinox asking for a portal account. Nothing here is an account — <b>Create account</b> opens Register with the details filled in, where you pick the roles, and marks the request once the account exists.',
  waiting: 'Waiting — {{n}}',
  waitingOf: 'Waiting — {{n}} of {{total}}',
  decided: 'Decided — {{n}}',
  decidedOf: 'Decided — {{n}} of {{total}}',
  loading: 'Loading…',
  noMatch: 'Nothing matches those filters.',
  nothingWaiting: 'Nothing waiting.',
  nothingDecided: 'Nothing decided yet.',
  whyPh: 'Why? The person is told this.',
  reject: 'Reject',
  cancel: 'Cancel',
  createAccount: 'Create account',
  req: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    company: 'Company',
    contact: 'Your Helinox contact',
    contactPh: 'Who you work with',
    error: 'Something went wrong. Please try again.',
    noReach: 'Could not reach the portal. Please try again.',
    title: 'Request access',
    thanks: 'Thank you. Someone at Helinox will look at this and write to you.',
    backToSignIn: 'Back to sign in',
    subtitle: 'For vendors and partners. Tell us who you are and we will be in touch.',
    whatFor: 'What for',
    whatForPh: 'What you need the portal for',
    sending: 'Sending…',
    send: 'Send request',
  },
};

const ko = {
  col: {
    asked: '요청일',
    name: '이름',
    email: '이메일',
    company: '회사',
    contact: 'Helinox 담당자',
    reason: '용도',
    status: '결과',
    decidedBy: '처리자',
    decidedAt: '처리 일시',
    note: '메모',
    username: '아이디',
    action: '작업',
  },
  status: {
    approved: '승인',
    rejected: '반려',
    pending: '대기',
  },
  loadFailed: '요청을 불러오지 못했습니다.',
  failed: '처리되지 않았습니다.',
  rejectedMsg: '반려했습니다. 신청자에게 사유를 메일로 보냈습니다.',
  recorded: '기록했습니다.',
  filterBit: '{{col}}: {{values}}',
  sortedBy: '{{col}} 기준 정렬',
  showing: '{{total}}건 중 {{shown}}건 표시 — {{bits}}',
  clear: '해제',
  title: '액세스 요청',
  refresh: '새로고침',
  users: '사용자',
  note: 'Helinox 외부에서 포털 계정을 요청한 사람들입니다. 여기 있는 항목은 계정이 아닙니다 — <b>계정 생성</b>을 누르면 정보가 채워진 사용자 생성 화면이 열리고, 그곳에서 역할을 고릅니다. 계정이 만들어지면 요청이 처리 완료로 표시됩니다.',
  waiting: '대기 — {{n}}',
  waitingOf: '대기 — {{total}}건 중 {{n}}건',
  decided: '처리 완료 — {{n}}',
  decidedOf: '처리 완료 — {{total}}건 중 {{n}}건',
  loading: '불러오는 중…',
  noMatch: '필터에 맞는 항목이 없습니다.',
  nothingWaiting: '대기 중인 요청이 없습니다.',
  nothingDecided: '아직 처리된 요청이 없습니다.',
  whyPh: '사유를 입력하세요. 신청자에게 전달됩니다.',
  reject: '반려',
  cancel: '취소',
  createAccount: '계정 생성',
  req: {
    firstName: '이름',
    lastName: '성',
    email: '이메일',
    company: '회사',
    contact: 'Helinox 담당자',
    contactPh: '함께 일하는 사람',
    error: '문제가 발생했습니다. 다시 시도하세요.',
    noReach: '포털에 연결할 수 없습니다. 다시 시도하세요.',
    title: '액세스 요청',
    thanks: '감사합니다. Helinox 담당자가 검토한 뒤 연락드리겠습니다.',
    backToSignIn: '로그인으로 돌아가기',
    subtitle: '벤더와 파트너를 위한 요청입니다. 어떤 분인지 알려 주시면 연락드리겠습니다.',
    whatFor: '용도',
    whatForPh: '포털을 어떤 용도로 사용하실지 적어 주세요',
    sending: '보내는 중…',
    send: '요청 보내기',
  },
};

const vi = {
  col: {
    asked: 'Ngày yêu cầu',
    name: 'Tên',
    email: 'Email',
    company: 'Công ty',
    contact: 'Người liên hệ Helinox',
    reason: 'Mục đích',
    status: 'Kết quả',
    decidedBy: 'Người xử lý',
    decidedAt: 'Thời điểm',
    note: 'Ghi chú',
    username: 'Tên đăng nhập',
    action: 'Thao tác',
  },
  status: {
    approved: 'Đã duyệt',
    rejected: 'Bị từ chối',
    pending: 'Đang chờ',
  },
  loadFailed: 'Không đọc được các yêu cầu.',
  failed: 'Thao tác không thành công.',
  rejectedMsg: 'Đã từ chối. Người đăng ký đã nhận email kèm lý do của bạn.',
  recorded: 'Đã ghi nhận.',
  filterBit: '{{col}}: {{values}}',
  sortedBy: 'sắp xếp theo {{col}}',
  showing: 'Đang hiện {{shown}} / {{total}} — {{bits}}',
  clear: 'Xóa',
  title: 'Yêu cầu truy cập',
  refresh: 'Làm mới',
  users: 'Người dùng',
  note: 'Những người ngoài Helinox yêu cầu tài khoản portal. Các mục ở đây chưa phải là tài khoản — <b>Tạo tài khoản</b> mở màn hình tạo người dùng với thông tin đã điền sẵn, nơi bạn chọn vai trò, và đánh dấu yêu cầu khi tài khoản đã được tạo.',
  waiting: 'Đang chờ — {{n}}',
  waitingOf: 'Đang chờ — {{n}} / {{total}}',
  decided: 'Đã xử lý — {{n}}',
  decidedOf: 'Đã xử lý — {{n}} / {{total}}',
  loading: 'Đang tải…',
  noMatch: 'Không có mục nào khớp với bộ lọc.',
  nothingWaiting: 'Không có yêu cầu nào đang chờ.',
  nothingDecided: 'Chưa có yêu cầu nào được xử lý.',
  whyPh: 'Lý do? Người đăng ký sẽ được thông báo.',
  reject: 'Từ chối',
  cancel: 'Hủy',
  createAccount: 'Tạo tài khoản',
  req: {
    firstName: 'Tên',
    lastName: 'Họ',
    email: 'Email',
    company: 'Công ty',
    contact: 'Người liên hệ tại Helinox',
    contactPh: 'Người bạn làm việc cùng',
    error: 'Đã có lỗi xảy ra. Vui lòng thử lại.',
    noReach: 'Không kết nối được portal. Vui lòng thử lại.',
    title: 'Yêu cầu truy cập',
    thanks: 'Cảm ơn bạn. Người phụ trách tại Helinox sẽ xem xét và liên hệ với bạn.',
    backToSignIn: 'Quay lại đăng nhập',
    subtitle: 'Dành cho nhà cung cấp và đối tác. Hãy cho chúng tôi biết bạn là ai, chúng tôi sẽ liên hệ lại.',
    whatFor: 'Mục đích',
    whatForPh: 'Bạn cần portal để làm gì',
    sending: 'Đang gửi…',
    send: 'Gửi yêu cầu',
  },
};

const zh = {
  col: {
    asked: '申请时间',
    name: '姓名',
    email: '邮箱',
    company: '公司',
    contact: 'Helinox 联系人',
    reason: '用途',
    status: '结果',
    decidedBy: '处理人',
    decidedAt: '处理时间',
    note: '备注',
    username: '用户名',
    action: '操作',
  },
  status: {
    approved: '已批准',
    rejected: '已驳回',
    pending: '待处理',
  },
  loadFailed: '无法读取申请。',
  failed: '操作未成功。',
  rejectedMsg: '已驳回。已将您的理由通过邮件发送给申请人。',
  recorded: '已记录。',
  filterBit: '{{col}}：{{values}}',
  sortedBy: '按{{col}}排序',
  showing: '显示 {{shown}} / {{total}} — {{bits}}',
  clear: '清除',
  title: '访问申请',
  refresh: '刷新',
  users: '用户',
  note: 'Helinox 外部人员申请门户账户。这里的条目并不是账户 — <b>创建账户</b>会打开已填好信息的创建用户页面，您在其中选择角色；账户创建后该申请会被标记。',
  waiting: '待处理 — {{n}}',
  waitingOf: '待处理 — {{n}} / {{total}}',
  decided: '已处理 — {{n}}',
  decidedOf: '已处理 — {{n}} / {{total}}',
  loading: '加载中…',
  noMatch: '没有符合筛选条件的项目。',
  nothingWaiting: '没有待处理的申请。',
  nothingDecided: '尚无已处理的申请。',
  whyPh: '原因？会告知申请人。',
  reject: '驳回',
  cancel: '取消',
  createAccount: '创建账户',
  req: {
    firstName: '名',
    lastName: '姓',
    email: '邮箱',
    company: '公司',
    contact: '您的 Helinox 联系人',
    contactPh: '与您合作的人',
    error: '出现问题，请重试。',
    noReach: '无法连接门户，请重试。',
    title: '申请访问',
    thanks: '谢谢。Helinox 的工作人员会查看并与您联系。',
    backToSignIn: '返回登录',
    subtitle: '面向供应商和合作伙伴。请告诉我们您是谁，我们会与您联系。',
    whatFor: '用途',
    whatForPh: '您需要使用门户做什么',
    sending: '发送中…',
    send: '发送申请',
  },
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "col": {
    "asked": "Demandé le",
    "name": "Nom",
    "email": "E-mail",
    "company": "Société",
    "contact": "Contact Helinox",
    "reason": "Motif",
    "status": "Résultat",
    "decidedBy": "Par",
    "decidedAt": "Date",
    "note": "Note",
    "username": "Nom d'utilisateur",
    "action": "Action"
  },
  "status": {
    "approved": "Approuvée",
    "rejected": "Rejetée",
    "pending": "En attente"
  },
  "loadFailed": "Impossible de lire les demandes.",
  "failed": "L'opération n'a pas abouti.",
  "rejectedMsg": "Rejetée. Le demandeur a reçu votre motif par e-mail.",
  "recorded": "Enregistré.",
  "filterBit": "{{col}} : {{values}}",
  "sortedBy": "trié par {{col}}",
  "showing": "Affichage de {{shown}} sur {{total}} — {{bits}}",
  "clear": "Effacer",
  "title": "Demandes d'accès",
  "refresh": "Actualiser",
  "users": "Utilisateurs",
  "note": "Personnes extérieures à Helinox qui demandent un compte portail. Rien ici n'est un compte — <b>Créer le compte</b> ouvre Register avec les informations déjà remplies, où vous choisissez les rôles, et marque la demande une fois le compte créé.",
  "waiting": "En attente — {{n}}",
  "waitingOf": "En attente — {{n}} sur {{total}}",
  "decided": "Traitées — {{n}}",
  "decidedOf": "Traitées — {{n}} sur {{total}}",
  "loading": "Chargement…",
  "noMatch": "Aucun résultat pour ces filtres.",
  "nothingWaiting": "Rien en attente.",
  "nothingDecided": "Aucune décision pour l'instant.",
  "whyPh": "Pourquoi ? La personne en sera informée.",
  "reject": "Rejeter",
  "cancel": "Annuler",
  "createAccount": "Créer le compte",
  "req": {
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "E-mail",
    "company": "Société",
    "contact": "Votre contact chez Helinox",
    "contactPh": "La personne avec qui vous travaillez",
    "error": "Une erreur s'est produite. Veuillez réessayer.",
    "noReach": "Impossible de joindre le portail. Veuillez réessayer.",
    "title": "Demander un accès",
    "thanks": "Merci. Une personne de Helinox examinera votre demande et vous répondra.",
    "backToSignIn": "Retour à la connexion",
    "subtitle": "Pour les fournisseurs et partenaires. Dites-nous qui vous êtes et nous vous recontacterons.",
    "whatFor": "Objet de la demande",
    "whatForPh": "Pourquoi vous avez besoin du portail",
    "sending": "Envoi en cours…",
    "send": "Envoyer la demande"
  }
};
const ja = {
  "col": {
    "asked": "申請日",
    "name": "名前",
    "email": "メール",
    "company": "会社",
    "contact": "Helinox の担当者",
    "reason": "用途",
    "status": "結果",
    "decidedBy": "判断者",
    "decidedAt": "日時",
    "note": "メモ",
    "username": "ユーザー名",
    "action": "操作"
  },
  "status": {
    "approved": "承認済み",
    "rejected": "却下",
    "pending": "保留中"
  },
  "loadFailed": "申請を読み込めませんでした。",
  "failed": "処理が完了しませんでした。",
  "rejectedMsg": "却下しました。申請者に理由をメールで送信しました。",
  "recorded": "記録しました。",
  "filterBit": "{{col}}：{{values}}",
  "sortedBy": "{{col}}で並べ替え",
  "showing": "{{total}}件中{{shown}}件を表示 — {{bits}}",
  "clear": "クリア",
  "title": "アクセス申請",
  "refresh": "更新",
  "users": "ユーザー",
  "note": "ポータルアカウントを申請している Helinox 社外の方々です。ここにあるものはアカウントではありません。<b>アカウントを作成</b>を押すと、情報が入力済みの Register が開き、そこでロールを選択します。アカウントが作成されると、申請に印が付きます。",
  "waiting": "待機中 — {{n}}",
  "waitingOf": "待機中 — {{total}}件中{{n}}件",
  "decided": "判断済み — {{n}}",
  "decidedOf": "判断済み — {{total}}件中{{n}}件",
  "loading": "読み込み中…",
  "noMatch": "これらのフィルターに一致するものはありません。",
  "nothingWaiting": "待機中のものはありません。",
  "nothingDecided": "まだ判断されたものはありません。",
  "whyPh": "理由は？ 申請者に伝えられます。",
  "reject": "却下",
  "cancel": "キャンセル",
  "createAccount": "アカウントを作成",
  "req": {
    "firstName": "名",
    "lastName": "姓",
    "email": "メールアドレス",
    "company": "会社名",
    "contact": "Helinox の担当者",
    "contactPh": "やり取りのある方",
    "error": "エラーが発生しました。もう一度お試しください。",
    "noReach": "ポータルに接続できませんでした。もう一度お試しください。",
    "title": "アクセス申請",
    "thanks": "ありがとうございます。Helinox の担当者が内容を確認し、ご連絡します。",
    "backToSignIn": "サインインに戻る",
    "subtitle": "仕入先およびパートナー向けです。お客様の情報をお知らせいただければ、ご連絡いたします。",
    "whatFor": "用途",
    "whatForPh": "ポータルを必要とする理由",
    "sending": "送信中…",
    "send": "申請を送信"
  }
};

const dictionary = { ns: 'xAccess', en, ko, vi, zh, fr, ja };

export default dictionary;
